<template>
    <div class="main">
        <div class="select">
            <div>
                <a-select
                    style="width: 150px; margin-right: 10px; margin-bottom: 10px"
                    @change="handleCountryChange"
                    :value="countrys[0].cn"
                >
                    <a-select-option v-for="item in countrys" :key="item" :value="item">{{ item.cn }}</a-select-option>
                </a-select>
            </div>
            <div>
                <a-select
                    style="width: 150px; margin-right: 10px; margin-bottom: 10px"
                    @change="handleChange"
                    :value="playerName"
                >
                    <a-select-option v-for="item in current_country_players" :key="item.name" :value="item.name">{{
                        '#' + item.num + item.name
                    }}</a-select-option>
                </a-select>
            </div>
        </div>
        <a-table
            class="table"
            :columns="columns"
            :data-source="currentData"
            :bordered="true"
            :scroll="{ x: '100%' }"
            size="small"
            :pagination="false"
            :row-key="(record, index) => index"
        >
            <template v-for="item in columns" :key="item.key" #[item.key]="{ record, text }">
                <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(record, item)">{{ text.value }}</span>
            </template>
        </a-table>
        <video-dialog
            :videoTitle="videoTitle"
            :visible="showVideo"
            :header="`https://k8-data-analysis.oss-cn-beijing.aliyuncs.com/2021世预赛视频/${date}/`"
            :videos="videos"
            @close="close"
        />
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import videoDialog from '@/components/videoDialog'

import { useRoute } from 'vue-router'
// import teamData from './assets/jsonList/man_offensive_3v3.json'
export default defineComponent({
    name: 'Offensive',
    components: {
        videoDialog,
    },
    setup() {
        const data = ref([])
        const currentData = ref()
        const showVideo = ref(false)
        const videoTitle = ref()
        const videos = ref([])
        const date = ref('')
        const countrys = ref([
            {
                cn: '中国',
                en: 'China',
            },
            {
                cn: '日本',
                en: 'Japan',
            },
        ])
        const playerName = ref(undefined)
        const current_country_players = ref()

        const columns = [
            {
                title: '进攻方式',
                dataIndex: 'PLAYTYPE',
                key: 'PLAYTYPE',
                width: 80,
                align: 'center',
                fixed: 'left',
                customCell: () => {
                    return { style: { 'font-weight': '600' } }
                },
            },
            {
                title: '进攻机会',
                dataIndex: 'PLAY',
                key: 'PLAY',
                width: 45,
                align: 'center',
                slots: { customRender: 'PLAY' },
            },
            {
                title: '得分',
                dataIndex: 'score',
                key: 'score',
                width: 50,
                align: 'center',
                slots: { customRender: 'score' },
            },
            {
                title: '得分率',
                dataIndex: 'SCOREperc',
                key: 'SCOREperc',
                width: 65,
                align: 'center',
            },
            {
                title: '篮下出手',
                dataIndex: 'RA',
                key: 'RA',
                width: 45,
                align: 'center',
                slots: { customRender: 'RA' },
            },
            {
                title: '篮下命中',
                dataIndex: 'RM',
                key: 'RM',
                width: 45,
                align: 'center',
                slots: { customRender: 'RM' },
            },
            {
                title: '篮下不中',
                dataIndex: 'Rm',
                key: 'Rm',
                width: 45,
                align: 'center',
                slots: { customRender: 'Rm' },
            },
            {
                title: '中距离\n出手',
                dataIndex: 'MIDA',
                key: 'MIDA',
                width: 65,
                align: 'center',
                slots: { customRender: 'MIDA' },
            },
            {
                title: '中距离\n命中',
                dataIndex: 'MIDM',
                key: 'MIDM',
                width: 65,
                align: 'center',
                slots: { customRender: 'MIDM' },
            },
            {
                title: '中距离\n不中',
                dataIndex: 'MIDm',
                key: 'MIDm',
                width: 65,
                align: 'center',
                slots: { customRender: 'MIDm' },
            },
            {
                title: '三分出手',
                dataIndex: 'THREEPA',
                key: 'THREEPA',
                width: 50,
                align: 'center',
                slots: { customRender: 'THREEPA' },
            },
            {
                title: '三分命中',
                dataIndex: 'THREEPM',
                key: 'THREEPM',
                width: 50,
                align: 'center',
                slots: { customRender: 'THREEPM' },
            },
            {
                title: '三分不中',
                dataIndex: 'THREEPm',
                key: 'THREEPm',
                width: 50,
                align: 'center',
                slots: { customRender: 'THREEPm' },
            },
            {
                title: '篮下比重',
                dataIndex: 'RRATIO',
                key: 'RRATIO',
                width: 65,
                align: 'center',
            },
            {
                title: '中距离\n比重',
                dataIndex: 'MIDRATIO',
                key: 'MIDRATIO',
                width: 65,
                align: 'center',
            },
            {
                title: '三分比重',
                dataIndex: 'THREERATIO',
                key: 'THREERATIO',
                width: 65,
                align: 'center',
            },
            {
                title: '有效命\n中率',
                dataIndex: 'EFG',
                key: 'EFG',
                width: 65,
                align: 'center',
            },
            {
                title: '失误',
                dataIndex: 'TO',
                key: 'TO',
                width: 50,
                align: 'center',
                slots: { customRender: 'TO' },
            },
            {
                title: '失误率',
                dataIndex: 'TORATIO',
                key: 'TORATIO',
                width: 65,
                align: 'center',
            },
            {
                title: '造罚球',
                dataIndex: 'ZFQ',
                key: 'ZFQ',
                width: 60,
                align: 'center',
                slots: { customRender: 'ZFQ' },
            },
            {
                title: '造罚球率',
                dataIndex: 'FTRATIO',
                key: 'FTRATIO',
                width: 65,
                align: 'center',
            },
        ]
        onMounted(() => {
            const route = useRoute()
            date.value = route.query.type
            console.log('data host====', date.value)
            data.value = require('../../assets/word_cup_data/' + date.value + '/player_play_type_data.json')
            current_country_players.value = data.value.filter((item) => {
                return item.team === countrys.value[0].en
            })
            playerName.value = current_country_players.value[0].name
            currentData.value = data.value[0].playTypes
        })

        const showRow = (record, item) => {
            let type = item.title === '进攻机会' ? '' : '-' + item.title
            videoTitle.value = record.PLAYTYPE + type
            record[item.key].time.forEach((item) => {
                videos.value.push(item + '.mp4')
            })
            showVideo.value = true
        }

        const hasVideo = (item) => {
            return item.value != 0
        }

        const close = () => {
            console.log(data.value)
            showVideo.value = false
        }

        const handleChange = (v) => {
            playerName.value = v
            currentData.value = null
            data.value.forEach((item) => {
                if (item.name == playerName.value) {
                    currentData.value = item.playTypes
                }
            })
        }
        const handleCountryChange = (v) => {
            current_country_players.value = data.value.filter((item) => {
                return item.team === v.en
            })
            playerName.value = current_country_players.value[0].name
            data.value.forEach((item) => {
                if (item.name == playerName.value) {
                    currentData.value = item.playTypes
                }
            })
        }

        return {
            columns,
            data,
            countrys,
            currentData,
            showVideo,
            showRow,
            videoTitle,
            videos,
            videos,
            close,
            handleChange,
            handleCountryChange,
            date,
            current_country_players,
            playerName,
            hasVideo,
        }
    },
})
</script>

<style lang="less" scoped>
.main {
    width: 100vw;
    height: 100vh;
    padding: 10px 10px;
    background: url('../../assets/bg_word_cup.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.select {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: start;
    width: 100%;
}

.table {
    width: 100%;
    border-radius: 2px;
}

.num {
    color: #129cfe;
    cursor: pointer;
}

.num_disable {
    color: #333;
}
</style>
